import styles from './template.css';
import template from './template';
import {AoflElement, customElement, property} from '@aofl/element';
import {i18nMixin} from '@aofl/i18n-mixin';

/**
 * @summary ActionItem
 * @extends {AoflElement}
 */
@customElement('action-item')
class ActionItem extends i18nMixin(AoflElement) {
  /**
   * Creates an instance of ActionItem.
   */
  constructor() {
    super();
  }

  @property({type: String, attribute: true})
  icon = '';

  @property({type: Number, attribute: true})
  count = '';

  @property({type: String, attribute: true})
  message = '';

  @property({type: Boolean})
  isClickable = true;

  onClick() {
    this.dispatchEvent(new CustomEvent('on-click', {
      composed: true,
      bubbles: true,
    }));
  }

  /**
   * @readonly
   */
  static is = 'action-item';
  /**
   *
   * @return {Object}
   */
  render() {
    return super.render({
      default: {template, styles: [styles]}
    });
  }
}

export default ActionItem;
